import React from "react";
import { cx } from "class-variance-authority";

import { Paragraph } from "../Typography/Typography";

import "./EmptyStateBox.scss";

type EmptyStateBoxProps = React.PropsWithChildren<{
    className?: string;
}>

export function EmptyStateBox({ children, className }: EmptyStateBoxProps) {
    return (
        <div className={cx("empty-state-box", className)}>
            <Paragraph className="empty-state-box__text" variant="body-2" color="mid-contrast">
                {children}
            </Paragraph>
        </div>
    );
}
